import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState, useEffect } from "react";
import axios from "axios";
import "./income.css";
import { useNavigate } from "react-router-dom";

function Income() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    amount: "",
    category: "",
    source: "",
    description: "",
    date: "",
  });

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${INVENTORY_API_BASE_URL}/get-vendors`
        );
        const uniqueCategories = [
          ...new Set(
            response.data.map((vendor) => vendor.category).filter(Boolean)
          ),
        ];
        setCategories(uniqueCategories);
      } catch (error) {
        console.error("Failed to fetch vendor categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${INVENTORY_API_BASE_URL}/api/income`, formData);
      alert("Income data submitted successfully!");
      setFormData({
        amount: "",
        category: "",
        source: "",
        description: "",
        date: "",
      });
      navigate("/incomelist");
    } catch (error) {
      alert("Submission failed!");
      console.error(error);
    }
  };

  return (
    <form className="expenseform-container" onSubmit={handleSubmit}>
      <h4 style={{ textAlign: "center" }}>Income</h4>

      <div>
        <label>Amount:</label>
        <input
          type="text"
          name="amount"
          value={formData.amount}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label>Category:</label>
        <select
          name="category"
          value={formData.category}
          onChange={handleChange}
          required
        >
          <option value="">Select Category</option>
          {categories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label>Source:</label>
        <input
          type="text"
          name="source"
          value={formData.source}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label>Description:</label>
        <input
          type="text"
          name="description"
          value={formData.description}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label>Date:</label>
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <button type="submit" className="submit-btn">
          Submit
        </button>
      </div>
    </form>
  );
}

export default Income;
